export const PLAN_INACTIVE_CODE = 'PLAN_INACTIVE';
export const PLAN_INACTIVE_MESSAGE = 'O plano da sua empresa está inativo. Entre em contato com o administrador.';

const AUTH_ERROR_STORAGE_KEY = 'authError';

export const saveToken = (token: string) => {
    localStorage.setItem('token', token);
}

export const getToken = () => {
    return localStorage.getItem('token');
}

export const removeToken = () => {
    localStorage.removeItem('token');
}

export const saveAuthError = (message: string) => {
    sessionStorage.setItem(AUTH_ERROR_STORAGE_KEY, message);
}

export const consumeAuthError = () => {
    const message = sessionStorage.getItem(AUTH_ERROR_STORAGE_KEY);

    if (message) {
        sessionStorage.removeItem(AUTH_ERROR_STORAGE_KEY);
    }

    return message;
}

export const redirectToLoginOnInactivePlan = (code?: string) => {
    if (code !== PLAN_INACTIVE_CODE) {
        return false;
    }

    removeToken();
    saveAuthError(PLAN_INACTIVE_MESSAGE);
    window.location.replace('/');

    return true;
}

export const headerAuthorization = () => {
    const token = getToken();
    return { 'Authorization': `Bearer ${token}` }
}
